export default __webpack_public_path__ + "static/media/dog.3f20782e.png";